export const reverseStringResult = (str) => str.split("=").reverse().join("=");

export const alignStrings = (str) => str.trim().replace(/\s+/g,"").toLowerCase();

export const adjustStep = (step) => {
    const subSteps = step.split(/\\\\+/);
    const actionRow = subSteps.length === 2
        ? /[A-Za-z]+/.test(subSteps[0])
            ? "\\" + subSteps[0].split("\\").join("\\quad\\")
            : subSteps[0].split("\\").join("\\quad\\")
        : null;
    const stepRow = subSteps.length === 2 ? subSteps[1] : subSteps[0];

    return [actionRow, stepRow];
}
